import { useTranslation } from 'react-i18next';
import AnswerContainer from './answer-container';
import NovartisContactFormButton from './novartis-contact-form-button';
import { CURRENT_INSTANCE } from '../../tenant';
import MarkdownRenderer from '../common/markdown-renderer';

interface NoAnswerMessageProps {
  userQuery?: string;
}

function NoAnswerMessage(props: NoAnswerMessageProps) {
  const { t } = useTranslation();

  return (
    <AnswerContainer>
      <div>
        {t('chat.response.contact_medical_info_long')}
        <br />
        <br />
        <MarkdownRenderer content={CURRENT_INSTANCE.content.medicalInfo} />
        <NovartisContactFormButton query={props.userQuery} />
      </div>
    </AnswerContainer>
  );
}

export default NoAnswerMessage;
